import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// images
import INVITE from "../../../assets/images/icons/profile.svg";
import Copy from "../../../assets/images/icons/copy.svg";
import { EMPTY } from "../../../assets/images/pictures/images";
import ORDERS from "../../../assets/images/icons/orders.svg";
import REFERALS from "../../../assets/images/icons/referrals.svg";
import LOCATION from "../../../assets/images/icons/Location.svg";
import PASSWORD from "../../../assets/images/icons/password.svg";
import DELETE from "../../../assets/images/icons/delete.svg";
import WALLET from "../../../assets/images/icons/wallet.svg";
import PROFILE from "../../../assets/images/icons/profile.svg";
// import Button from "../../../components/buttons/buttons";
import NavBarUser from "../../../components/navigation/NavBarUser";
import { copyTextToClipboard } from "../../../components/helpers";
import { getUserFromCookies } from "../../../utils/Auth";
import Container from "../../../components/container/container";

const navigation = [
  { name: "Profile", href: "info", icon: PROFILE },
  { name: "My Addresses", href: "addresses", icon: LOCATION },
  { name: "My Orders", href: "orders", icon: ORDERS },
  { name: "My Referrals", href: "referrals", icon: REFERALS },
  { name: "My Invites", href: "invites", icon: INVITE },
  { name: "My Payments", href: "payments", icon: WALLET },
  { name: "KYC Verification", href: "kyc-verification", icon: PASSWORD },
  { name: "Change Password", href: "password", icon: PASSWORD },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ProfileMobile() {
  const user = getUserFromCookies();
  const navigate = useNavigate();
  const { active_tab } = useParams();

  const { myProfile } = useSelector((state) => state.profile);

  /**
   * Truncate transaction ref and add ellipsis in middle
   *
   * @param {string} string
   * @param {number} lengthToShow
   * @param {string} seperator
   * @returns {string}
   */
  const truncateText = (string, lengthToShow = 25, separator = "...") => {
    if (string?.length <= lengthToShow) return string;

    const sepLen = separator?.length;
    const charsToShow = lengthToShow - sepLen;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return (
      string?.substr(0, frontChars) +
      separator +
      string?.substr(string.length - backChars)
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onImageError = (e) => {
    e.target.src = EMPTY;
  };

  return (
    <div data-test="personalComponent">
      <NavBarUser />
      <Container>
        <div className="pt-4 sm:pt-2 sm:flex gap-8 sm:justify-between items-start mx-auto sm:my-12">
          <div className="relative px-4 sm:w-[375px] w-full sm:rounded-md bg-white sm:h-[1000px] sm:ml-7 shadow-2xl ">
            {/* <div className="absolute top-5 right-5 z-10">
              <Button.Secondary
                title={"Edit Info"}
                onClick={() => navigate(`/profile/info`)}
              />
            </div> */}

            <div className="flex flex-col items-center relative pt-16">
              <img
                src={myProfile?.picture}
                alt="profile"
                onError={onImageError}
                className=" border border-primary p-1 rounded-full w-[86px] h-[86px] sm:h-[86px] mb-4 sm:mb-2"
              />
              <p className=" text-2xl font-medium text-[#344867] mb-3 sm:mb-2 capitalize">
                {user?.name}
              </p>
              <p className=" text-base font-normal text-[#344867] ">
                {user?.email}
              </p>
              <div className="flex">
                <p className=" text-base font-normal text-[#344867] ">
                  ID: {truncateText(user?.id)}
                </p>
                <img
                  className="ml-2 w-6 h-6"
                  src={Copy}
                  alt="copy-icon"
                  onClick={() => copyTextToClipboard(user.id)}
                />
              </div>
            </div>

            <nav className="flex-1 space-y-1 px-2 mt-12">
              {navigation.map((item, index) => (
                <div key={index} className="border-b-2 mt-1 mb-2">
                  <div
                    className={classNames(
                      item.href === active_tab
                        ? "bg-gray-100 text-primary"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                      "flex text-center items-center my-2 px-2 py-2 cursor-pointer"
                    )}
                    onClick={() => navigate(`/profile/${item.href}`)}
                  >
                    <img src={item.icon} alt="icon" className="mr-3 w-8 h-8" />
                    <p className="text-sm text-[#344867]">{item.name}</p>
                  </div>
                </div>
              ))}
            </nav>

            <div className="border-b-2 px-2 mt-2 mb-32">
              <div
                className="flex text-center items-center px-2 mb-3 mt-3 cursor-pointer"
                onClick={() => navigate(`/profile/delete`)}
              >
                <img src={DELETE} alt="icon" className="mr-3" />
                <p className=" text-sm text-primary ">Delete Account</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
